export default __webpack_public_path__ + "static/malgorzata-dolnyslask1_small-34a756335cd29f44dee5050464987058.jpg";